<template>
  <v-autocomplete
    hide-details
    v-model="defaultData"
    @change="onChange"
    dense
    :items="data"
    :label="label"
    outlined
    clearable
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    label: String,
    items: Array,
    defaultData: {
      type: Object,
      default: () => ({})
    }
  },
  name: 'SelectEntity',
  data() {
    return {
      data: []
    }
  },
  created() {
    if (this.items && this.items.length) {
      this.data = this.items.map(i => {
        return {
          text: i.text,
          value: i.value
        }
      })
    }
    if (this.defaultData) this.$emit('changeItem', this.defaultData.value)
  },
  methods: {
    onChange(value) {
      this.$emit('changeItem', value)
    }
  }
}
</script>
